import { render, staticRenderFns } from "./AssetsForm.vue?vue&type=template&id=f83321d0"
import script from "./AssetsForm.vue?vue&type=script&lang=js"
export * from "./AssetsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports